import { initializeApp } from 'firebase/app';
import { getFirestore, collection, addDoc, serverTimestamp } from 'firebase/firestore';
import { getAuth } from 'firebase/auth';
import { getStorage } from 'firebase/storage';

const config = {
  apiKey:            process.env.REACT_APP_FIREBASE_API_KEY,
  authDomain:        process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
  projectId:         process.env.REACT_APP_FIREBASE_PROJECT_ID,
  storageBucket:     process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
  appId:             process.env.REACT_APP_FIREBASE_APP_ID,
};

export const firebaseConfig = config;

const app = initializeApp(config);

export const db      = getFirestore(app);
export const auth    = getAuth(app);
export const storage = getStorage(app);

// Secondary app used for creating new Firebase Auth accounts without
// signing out the currently logged-in admin.
let _secondaryApp = null;
export function getSecondaryAuth() {
  if (!_secondaryApp) {
    _secondaryApp = initializeApp(config, 'secondary');
  }
  return getAuth(_secondaryApp);
}

// Shared helper — write one audit log entry; silently swallows errors so it
// never breaks the primary operation that triggered it.
export async function addAuditLog(userId, userName, action, module) {
  try {
    await addDoc(collection(db, 'auditLogs'), {
      userId,
      userName,
      action,
      module,
      timestamp: serverTimestamp(),
    });
  } catch (e) {
    console.error('[AuditLog]', e);
  }
}
